// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3d3wQ","consentsList":"PatientConsents_consentsList__2KH4H","consentsListEmpty":"PatientConsents_consentsListEmpty__1Gcfu"};